import { render, staticRenderFns } from "./TextAlignDropDownSelector.vue?vue&type=template&id=7e8a6ed8&scoped=true&"
import script from "./TextAlignDropDownSelector.vue?vue&type=script&lang=ts&"
export * from "./TextAlignDropDownSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8a6ed8",
  null
  
)

export default component.exports